const riot = require('riot');

riot.tag2('page-error', '<div class="s-full f fh"> <div> <h2 class="text-center fs64 mb16">{statusCode || 999}</h2> <p class="white-space-pre-wrap mb16" if="{error}">{error.stack || error.toString()}</p> <div class="text-center"><a href="/">to TOP</a></div> </div> </div>', 'page-error,[data-is="page-error"]{display:block}', '', function(opts) {
    this.preload = ({req, res}) => {
      return {
        error: res.error,
        statusCode: res.statusCode,
      };
    };
});